import React, { useCallback, useEffect, useRef, useState } from "react";
import SponsorshipCard from "../components/cards/SponsorshipCard";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux-stores/store";
import { CampaignFilters, defaultCampaignFilters, fetchCampaigns, fetchCampaignsThunk, updateCampaignFilters } from "../redux-stores/slices/campaignSlice";
import InfluencerActionCard from "../components/influencer/InfluencerActionCard";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../constants/constants";
import CampaignSkeleton from "../skeletons/CampaignSkeleton";
import Ticker from "../components/header/Ticker";
import InvitedCampaigns from "../components/campaign/InvitedCampaigns";
import TaskSummary from "../components/collaborations/TaskSummary";
import "../styles/style.scss"
import { useSearchParams } from "react-router-dom";
import { decodeBase64, encodeBase64, generateUniqueKey } from "../utils/helpers";
import PendingSteps from "../components/collaborations/PendingSteps";
import influencerImg from "../assets/images/influencer.png"
import AllSponsorships from "../components/sponsorships/AllSponsorships";
import MarqueeTicker from "../components/Ticker/MarqueeTicker";
import { setHeader } from "../redux-stores/slices/layoutSlice";
import { defaultAppHeaderProps } from "../types/layout/layoutTypes";
const Sponsorships: React.FC = () => {
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const [searchParams, setSearchParams] = useSearchParams();

    const queryFilters = searchParams.get('filters');
    const dispatch = useDispatch<AppDispatch>();
    const isDesktop = useMediaQuery(isDesktopMediaQuery)
    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);
    const invitedCampaignsIdsRaw = useSelector((state: RootState) => state.campaigns.invited.list);
    const invitedCampaignsIds = invitedCampaignsIdsRaw.map((c) => c.uuid)
    // Get campaigns and other necessary data from Redux store
    const filters = useSelector((state: RootState) => state.campaigns.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const campaignsData = useSelector((state: RootState) => state.campaigns.filtered_lists[filterId!]);
    const campaigns = campaignsData?.list ?? [];
    const page = campaignsData?.page ?? 1;
    const has_more = campaignsData?.has_more ?? true;
    const loading = useSelector((state: RootState) => state.campaigns.loading);

    const [searchQuery, setSearchQuery] = useState('');
    const [initialLoading, setInitialLoading] = useState(true);

    const setFilters = (updatedFilters: CampaignFilters) => {

        const encodedFilters = encodeBase64(updatedFilters);

        setSearchParams({ filters: encodedFilters });
    }


    useEffect(() => {
        const decodedFilters = queryFilters ? decodeBase64(queryFilters, defaultCampaignFilters) : defaultCampaignFilters;
        dispatch(updateCampaignFilters({ ...decodedFilters, page: 1 }))
    }, [queryFilters])


    useEffect(() => {
        if (filters.page && filters.page === 1) {
            setInitialLoading(true);
        }
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            dispatch(fetchCampaignsThunk({ filters })).finally(() => {
                setFilterId(generateUniqueKey(filters, ['page']));
                setInitialLoading(false);
            })
        }, 500)

    }, [filters])

    useEffect(() => {
        setSearchQuery(filters.q ?? '');
    }, [filters.q])

    const nextPage = () => {
        if (has_more && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchCampaignsThunk({ filters: { ...filters, page: nextPageNumber } }))
        }
    }

    const searchTask = (q: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (q.trim().length > 3) {
                setFilters({ ...filters, q: q.trim(), page: 1 });
            } else if (q.trim().length === 0) {
                setFilters({ ...filters, q: '', page: 1 });
            }
        }, 500);
        setSearchQuery(q);
    }


    const invitesLoading = useSelector((state: RootState) => state.campaigns.invited.loading);


    return (
        <React.Fragment>
            <div className="page-header find-collabs-page-header position-relative pb-0">
                <div className="search-and-filter mt-5">
                    <div className="campaign-search-container position-relative flex-grow-1">
                        <span className="campaign-search-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M11.5 2.75C6.66751 2.75 2.75 6.66751 2.75 11.5C2.75 16.3325 6.66751 20.25 11.5 20.25C16.3325 20.25 20.25 16.3325 20.25 11.5C20.25 6.66751 16.3325 2.75 11.5 2.75ZM1.25 11.5C1.25 5.83908 5.83908 1.25 11.5 1.25C17.1609 1.25 21.75 5.83908 21.75 11.5C21.75 14.0605 20.8111 16.4017 19.2589 18.1982L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1982 19.2589C16.4017 20.8111 14.0605 21.75 11.5 21.75C5.83908 21.75 1.25 17.1609 1.25 11.5Z" fill="black" fillOpacity="0.5" />
                            </svg>
                        </span>
                        <input type="text" placeholder="Search By Brand" value={searchQuery} onChange={(e) => searchTask(e.target.value)} className="campaign-search-input" />
                        {
                            searchQuery &&
                            <span className='clear-search-icon'> <i className='fa fa-times' onClick={() => searchTask('')}></i> </span>
                        }
                    </div>
                    {/* <button className='new-btn new-btn-primary-outlined'>
                            <FilterIcon />
                            <span>Filter</span>
                        </button> */}
                </div>

                <div className="d-flex flex-column justify-content-between mt-3">
                    <div>
                        <PendingSteps />
                    </div>
                    <div className="tagline-and-image ">
                        <div className="tagline w-100 d-flex align-items-center justify-content-center gap-3">
                            <h3 className='page-header-title m-0'>FIND</h3>
                            <h3 className='page-header-title m-0'>COLLABS</h3>
                            <span className='tagline-sub-title'>Connect. Create. Grow.</span>
                        </div>
                        <img src={influencerImg} className='influencer-img tagline-image' alt="influencer" />
                    </div>
                </div>
            </div>
            <MarqueeTicker className="find-collabs-page-ticker" />
            <AllSponsorships />
        </React.Fragment>
    );
};

export default Sponsorships;